import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import * as Api from 'api';
import { Modal, Panel, Row, Col, Button } from 'react-bootstrap';
import { ClientFormNew } from './';
import { LoadingSpinner } from 'components';
const copy = obj => (JSON.parse(JSON.stringify(obj)));

class ClientCreate extends React.Component {
  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      loading: false,
      saving: false,
      client : {
        address: {},
        ...(this.props.client || {})
      }
    }
  }
  handleSave() {
    let { pathname } = this.props.routing.locationBeforeTransitions;

    if(this.props.onSave) {
      return this.props.onSave(this.state.client);
    }

    this.setState({ saving: true });
    Api.createClient(this.state.client)
    .then(response => {
      if(pathname == 'clients/canvassing') {
        this.props.selectClient(response._id)
        this.props.receiveClient(response)
      }
      else {
        this.props.push(`client/${response._id}`);
      }
    })
    .catch(ex => {
      console.log(ex);
      this.props.notify({ message: ex.message || ex });
    })
    .finally(() => {
      this.props.stopCreatingClient();
      this.setState({ saving: false })
    });
  }
  handleChange(value, name) {
    let copy_state = copy(this.state.client);
    let entity = copy_state;
    let names = name.split('.');

    while(names.length > 1) {
      let name = names.shift();
      if(!entity[name]) {
        entity[name] = {};
      }
      entity = entity[name];
    }

    entity[names.shift()] = value;
    this.setState({client: copy_state});
  }
  componentDidUpdate(prev_props) {
    if(!prev_props.show_create_client && (this.props.show_create_client && this.props.tmp_client)) {
      this.setState({client : this.props.tmp_client})
    }
    else if(prev_props.show_create_client && !this.props.show_create_client) {
      this.setState({client : {address : {}}})
    }
  }
  render() {
    const content = (
      <Panel
        header={<h3>{this.props.title || 'Create Client'}</h3>}
        bsStyle='primary'
        footer={
          <Row className="clearfix">
            <Col xs={12} sm={6}><Button onClick={this.props.onCancel || this.props.stopCreatingClient} bsStyle={'default'} block>Cancel</Button></Col>
            <Col xs={12} sm={6}>
              <Button
                onClick={this.handleSave}
                bsStyle={'success'}
                block
                >
                {this.state.saving ? <LoadingSpinner size={2}/> : 'Save'}
              </Button>
            </Col>
          </Row>}
        >
        <ClientFormNew entity={this.state.client} onChange={this.handleChange} />
      </Panel>
    )

    return(
      this.props.modal ?
      <Modal
        bsSize="large"
        className="edit-client-model"
        show={this.props.show_create_client}
        onHide={this.props.stopCreatingClient}
        aria-labelledby="contained-modal-title-lg"
        >
        {content}
      </Modal> : content
    )
  }
}

export default connect(({clients, routing}) => ({...clients, routing}), Actions)(ClientCreate);



// WEBPACK FOOTER //
// ./src/browser/components/client/client-create.js